import { useState } from "react"

export default function ExpandableSearch({ value, onChange, className = "" }) {
  const [isOpen, setIsOpen] = useState(false)

  const onClose = () => {
    setIsOpen(false)
    onChange("")
  }
  return (
    <div
      className={`position-relative d-flex align-items-center transition-all ${className}`}
      style={{ width: isOpen ? "320px" : "40px", transition: "0.3s" }}
    >
      {/* Search Icon */}
      <div
        className="cursor-pointer"
        style={{ zIndex: 2, cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className="bi bi-search fs-5 p-2" />
      </div>

      {/* Search Input */}
      {isOpen && (
        <div className="position-absolute top-0 start-0 w-100 d-flex align-items-center border rounded bg-white ps-4">
          <input
            autoFocus
            type="text"
            placeholder="Search..."
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="form-control border-0 shadow-none"
            style={{ height: "40px" }}
          />

          <i class="bi bi-x-circle"
            size={16}
            onClick={onClose}
            style={{
              position: "absolute",
              right: "10px",
              cursor: "pointer",
            }}
          />
        </div>
      )}
    </div>
  )
}